import { Component, OnInit, ViewEncapsulation, OnDestroy, Input } from '@angular/core';
import { PermanentSaving, ScheduleDate, Parameter, Employee, PeriodTypeEnum } from '@akiba/models_bimbo';
import { FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AppState } from 'projects/bimbo/src/app/models/appState';
import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { LogicService } from 'projects/bimbo/src/app/services/logic.service';
import { MatDialog } from '@angular/material';
import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import { CancelConfirmDialogComponent } from 'projects/bimbo/src/app/dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { InfoDialogComponent } from 'projects/bimbo/src/app/dialogs/info-dialog/info-dialog.component';
import { UiService } from 'projects/bimbo/src/app/services/ui.service';

@Component({
  selector: 'app-ps-cancellation',
  templateUrl: './ps-cancellation.component.html',
  styleUrls: ['./ps-cancellation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PsCancellationComponent implements OnInit, OnDestroy {

  //////////////////////////////////////
  permanentSavingParameter: Parameter | null = null;
  //////////////////////////////////////
  currentEmployee: Employee;
  //////////////////////////////////////
  permanentSaving = new PermanentSaving();

  formControlContributionAmount = new FormControl();
  formControlAnnualPerformanceBonusPercentage = new FormControl(null, [Validators.min(0), Validators.max(100)]);
  formControlProfitSharingPercentage = new FormControl(null, [Validators.min(0), Validators.max(100)]);
  formControlTargetBonusPercentage = new FormControl(null, [Validators.min(0), Validators.max(100)]);
  formControlYearEndAndPerformanceBonusPercentage = new FormControl(null, [Validators.min(0), Validators.max(100)]);

  beneficiariesTitles = ['Primer Beneficiario', 'Segundo Beneficiario', 'Tercer Beneficiario', 'Cuarto Beneficiario', 'Quinto Beneficiario',
    'Sexto Beneficiario', 'Séptimo Beneficiario', 'Octavo Beneficiario', 'Noveno Beneficiario', 'Décimo Beneficiario'];

  beneficiariesPrefix = ['firstBeneficiary', 'secondBeneficiary', 'thirdBeneficiary', 'fourthBeneficiary', 'fifthBeneficiary',
    'sixthBeneficiary', 'seventhBeneficiary', 'eighthBeneficiary', 'ninthBeneficiary', 'tenthBeneficiary'];

  beneficiariesControls = new Array<Array<FormControl>>();

  appLogicSubs: Subscription;
  @Input() contentLocation: AppState;
  constructor(public logicService: LogicService, public dialog: MatDialog, private dataService: DataSourceService, private UI: UiService, private authService: AuthenticationService) {

    const parameters = this.logicService.dataManager.parameterDataLoader.parameters ? this.logicService.dataManager.parameterDataLoader.parameters : [];

    this.currentEmployee = this.logicService.dataManager.proxyDataLoader.employee ? this.logicService.dataManager.proxyDataLoader.employee : this.logicService.dataManager.principalDataLoader.employee;
    this.permanentSavingParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.permanentSaving).find(e => e.savingParameterAppliesTo(this.currentEmployee));

    const minOrOne = this.logicService.minContribution(this.currentEmployee) === 0 ? 1 : this.logicService.minContribution(this.currentEmployee);
    this.formControlContributionAmount.setValidators([Validators.required, Validators.min(minOrOne), Validators.max(this.logicService.maxSavingContribution(this.currentEmployee))]);

    const obj = this.currentEmployee.permanentSavings ? this.currentEmployee.permanentSavings.toAny() : null;
    this.permanentSaving = new PermanentSaving(obj);

    this.permanentSaving.beneficiaries.values().forEach(element => {
      const f = [new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required]), new FormControl(null, [Validators.required, Validators.min(1), Validators.max(100)])];
      f[0].setValue(element.names);
      f[0].disable();
      f[1].setValue(element.firstLastName);
      f[1].disable();
      f[2].setValue(element.secondLastName);
      f[2].disable();
      f[3].setValue(element.relation);
      f[3].disable();
      f[4].setValue(element.percentage);
      f[4].disable();
      this.beneficiariesControls.push(f);
    });

  }

  ngOnInit() {

  }

  cancel(tabIndex: number, detailIndex: number | null) {

    const cancelRegistration = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea descartar los cambios hechos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Confirmar'
      }
    });

    cancelRegistration.afterClosed().subscribe(result => {
      if (result) {
        this.contentLocation.tabIndex = tabIndex;
        this.contentLocation.detailIndex = detailIndex;
        this.contentLocation.contentIndex = 0;
      }
    });
  }

  get currentScheduleDate(): ScheduleDate | null {
    const cpsp = this.permanentSavingParameter.savingParameter;
    const sd = cpsp ? cpsp.currentRegistrationScheduleDate(new Date()) : new ScheduleDate();
    return sd;
  }

  async logPermanentLoanMovements() {
    //salvar en logs alta
    const withdraws: Array<any> = [];
    const date = new Date();

    const paramLogs = {
      employeeNumber: this.currentEmployee.workInformation.employeeNumber,
      modificationDate: date,
      withdraws: withdraws,
      registerFor: this.authService.authEmployee.uid,
      action: 'ps-cancellation'
    }
    await this.dataService.saveLogPermanentLoanMovements(paramLogs).catch(error => {
      console.log(error);
      return;
    });
  }

  submitSubscription() {

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Esta seguro(a) que desea cancelar su inscripción en la Caja de Ahorro?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(result => {
      if (result) {

        this.UI.showSpinner();
        this.permanentSaving.status = 'canceled';
        this.permanentSaving.active = true;

        if (this.permanentSaving.total === 0) {
          this.permanentSaving.active = false;
        }

        const toObj = this.permanentSaving.toAny();
        this.logPermanentLoanMovements();
        this.dataService.updatePermanentSavings(this.currentEmployee.uid, toObj).then(async () => {

          this.contentLocation.tabIndex = 0;
          this.contentLocation.detailIndex = null;
          this.contentLocation.contentIndex = 0;

          this.UI.stopSpinner();
          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'Su solicitud se realizó con éxito',
              close: 'Aceptar'
            }
          });

        }).catch(error => {

          this.UI.stopSpinner();
          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'No fue posible cancelar el ahorro, inténtelo mas tarde',
              close: 'Aceptar'
            }
          });

        });
      }
    });
  }

  ngOnDestroy(): void {

    if (this.appLogicSubs && !this.appLogicSubs.closed) {
      this.appLogicSubs.unsubscribe();
      this.appLogicSubs = null;
    }

  }

}
